import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

declare global {
  interface Window {
    wpMailManagerI18n: any;
  }
}

if ( document.getElementById('wp-mail-manager-app') ) {
  ReactDOM.render(
    <App />,
    document.getElementById('wp-mail-manager-app')
  );
}
